import { render, staticRenderFns } from "./LargeBanner.vue?vue&type=template&id=668c06c8&"
import script from "./LargeBanner.vue?vue&type=script&lang=js&"
export * from "./LargeBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports